import { day as DAY_COLORS } from '@eb/eds-settings';
import { genTheme } from '../_internal/utils';

export default genTheme(null, DAY_COLORS);
